export default "__VITE_PUBLIC_ASSET__8b009eea__"